import { useWebMCP } from "@/hooks/useWebMCP";

const WebMCPProvider = () => {
  useWebMCP();
  return null;
};

export default WebMCPProvider;
